import { createContext, useEffect, useReducer } from "react";
import { AUTH_REDUCER_REMOVE_AUTH_DATA, STORAGE_KEY_AUTH_DATA } from "../common/constants";
import { AuthReducer } from "../Reducers/AuthReducer";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
	const [authData, dispatch] = useReducer(
		AuthReducer,
		{},
		() =>
			JSON.parse(window.localStorage.getItem(STORAGE_KEY_AUTH_DATA)) ?? {
				is_logged_in: false,
				user_data: {},
			}
	);

	const dispatchMiddleWare = (action) => {
		dispatch({ ...action, dispatch });
	};

	const localStorageListener = () => {
		const storageData = JSON.parse(window.localStorage.getItem(STORAGE_KEY_AUTH_DATA) ?? "{}");

		if (!storageData?.is_logged_in) dispatchMiddleWare({ type: AUTH_REDUCER_REMOVE_AUTH_DATA });
	};

	useEffect(() => {
		window.addEventListener("storage", localStorageListener);

		return () => window.removeEventListener("storage", localStorageListener);
	}, []);

	console.log("authdata: ", authData);

	return (
		<AuthContext.Provider value={{ authData, dispatch: dispatchMiddleWare }}>
			{props.children}
		</AuthContext.Provider>
	);
};

export default AuthContextProvider;
